var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('Navbar')],1),_c('div',{attrs:{"id":"contenedor"}},[_c('router-view')],1),_c('NotificacionesPush'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }